import { selectSelectedExportModeTab } from "@/store/modes/export-mode-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { createSelector } from "@reduxjs/toolkit";
import type { JSX } from "react";
import { ExportModeTab } from "./export-mode-types";
import { ScansExportTree } from "./scans-export/scans-export-tree";

/** @returns A panel that the export options can use to display relevant information such as project tree, scans list etc */
export function ExportModePanel(): JSX.Element | null {
  const selectedTab = useAppSelector(selectSelectedExportModeTab);

  if (selectedTab !== ExportModeTab.scans) {
    return null;
  }

  return <ScansExportTree />;
}

/**
 * @returns Whether the export mode panel should be shown based on the selected export mode tab
 */
export const selectShouldShowExportPanel = createSelector(
  [selectSelectedExportModeTab],
  (selectedTab: ExportModeTab) => selectedTab === ExportModeTab.scans,
);
